<template>
  <b-modal
    id="delete-file-manager-modal"
    @hidden="hidden"
    :visible="visible"
    :no-close-on-backdrop="loading"
    :no-close-on-esc="loading"
    centered
  >
    <template #modal-header>
      <h5 class="modal-title">حذف حساب‌های مدیریت فایل</h5>
    </template>
    <error-messages
      v-if="errorMessages.length > 0"
      :show="showError"
      :dismissible="true"
      @dismissed="dismissedError"
      :messages="errorMessages"
    />
    <p>
      پس از حذف دیگر به این حساب‌ها دسترسی ندارید و باید حساب‌های دیگری ایجاد
      کنید.
    </p>
    <p>آیا از حذف حساب‌ها مطمئنید!؟</p>
    <template #modal-footer>
      <b-button variant="secondary" @click="hidden" :disabled="loading">
        انصراف
      </b-button>
      <loading-btn
        :loading="loading"
        :disabled="loading"
        variant="danger"
        @click="deleteAccounts"
      >
        حذف حساب‌ها
      </loading-btn>
    </template>
  </b-modal>
</template>

<script>
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn.vue";
import { deleteFileManager } from "@/services/service";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  name: "DeleteFileManagerModal",
  components: {
    LoadingBtn,
    ErrorMessages
  },
  props: {
    visible: Boolean
  },
  data() {
    return {
      loading: false,
      showError: false,
      errorMessages: []
    };
  },
  methods: {
    reset: function() {
      this.loading = false;
      this.showError = false;
      this.errorMessages = [];
    },
    dismissedError: function() {
      this.showError = false;
    },
    hidden: function() {
      this.reset();
      this.$emit("hidden");
    },
    deleteAccounts: async function() {
      this.loading = true;
      const [error, data] = await deleteFileManager({
        serviceId: this.$route.params.serviceId
      });
      if (error) {
        this.errorMessages = error;
        this.showError = true;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          this.loading = false;
          this.$emit("deleteSuccess");
          this.hidden();
        } else {
          this.errorMessages = data.apiErrors;
          this.showError = true;
          this.loading = false;
        }
      }
    }
  }
};
</script>
